"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _react = _interopRequireWildcard(require("react"));
var _useClickAway = _interopRequireDefault(require("react-use/lib/useClickAway"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _reactUse = require("react-use");
var _hooks = require("../../hooks");
var _icon = require("./Icon");
var _option = _interopRequireDefault(require("./Option"));
var S = _interopRequireWildcard(require("./Dropdown.styles"));
var _typography = _interopRequireDefault(require("../Typography"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Dropdown = /*#__PURE__*/ _react.default.forwardRef(function(_param, ref) {
    var _options = _param.options, options = _options === void 0 ? [] : _options, name = _param.name, defaultValue = _param.defaultValue, onChange = _param.onChange, placeholder = _param.placeholder, disabled = _param.disabled, _colorVariant = _param.colorVariant, colorVariant = _colorVariant === void 0 ? "white" : _colorVariant, props = _objectWithoutProperties(_param, [
        "options",
        "name",
        "defaultValue",
        "onChange",
        "placeholder",
        "disabled",
        "colorVariant"
    ]);
    var localRef = (0, _react).useRef(null);
    var selectButtonRef = (0, _react).useRef(null);
    var _$ref3 = _slicedToArray((0, _reactUse).useToggle(false), 2), isOpen = _$ref3[0], setIsOpen = _$ref3[1];
    var _$ref1 = _slicedToArray((0, _react).useState(defaultValue), 2), value = _$ref1[0], setValue = _$ref1[1];
    var selectedOption = options === null || options === void 0 ? void 0 : options.find(function(option) {
        return option.value === value;
    });
    var onClick = (0, _react).useCallback(function() {
        setIsOpen();
    }, [
        setIsOpen
    ]);
    var handleOnChange = (0, _react).useCallback(function(changeValue) {
        var _$ref;
        setValue(changeValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(changeValue);
        setIsOpen(false);
        selectButtonRef === null || selectButtonRef === void 0 ? void 0 : (_$ref = selectButtonRef.current) === null || _$ref === void 0 ? void 0 : _$ref.focus();
    }, [
        onChange,
        setIsOpen
    ]);
    (0, _useClickAway).default(localRef, function() {
        setIsOpen(false);
    });
    (0, _hooks).useWindowResizeEffect(function() {
        return setIsOpen(false);
    });
    var _$ref2;
    return /*#__PURE__*/ (0, _jsxRuntime).jsxs(S.Wrapper, _objectSpread({
        ref: (0, _reactMergeRefs).default([
            localRef,
            ref
        ])
    }, props, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime).jsxs(S.DropdownButton, {
                type: "button",
                ref: selectButtonRef,
                isDisabled: disabled,
                name: name,
                id: name,
                onClick: onClick,
                colorVariant: colorVariant,
                isValue: !!value,
                isPlaceholder: !!placeholder,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime).jsx(S.DropdownButtonText, {
                        children: /*#__PURE__*/ (0, _jsxRuntime).jsx(_typography.default, {
                            variant: "body2",
                            children: (_$ref2 = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _$ref2 !== void 0 ? _$ref2 : placeholder
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime).jsx(S.DropdownButtonIcon, {
                        isOpen: isOpen,
                        children: /*#__PURE__*/ (0, _jsxRuntime).jsx(_icon.Caret, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime).jsx(S.Options, {
                role: "listbox",
                isOpen: isOpen,
                colorVariant: colorVariant,
                children: options.map(function(item) {
                    return /*#__PURE__*/ (0, _jsxRuntime).jsx(_option.default, {
                        name: "".concat(name, "-dropdown-option"),
                        label: item.label,
                        value: item.value,
                        colorVariant: colorVariant,
                        onChange: handleOnChange,
                        isSelected: value === item.value
                    }, item.label);
                })
            })
        ]
    }));
});
var _default = /*#__PURE__*/ _react.default.memo(Dropdown);
exports.default = _default;
